import type { z } from 'zod';

import { z as zod } from 'zod';

export const newsletterSchema = (t: (key: string, options?: Record<string, any>) => string) =>
  zod.object({
    email: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.email') })
      .email({ message: t('fields.invalid.email') }),
  });

export type NewsletterSchemaType = z.infer<ReturnType<typeof newsletterSchema>>;
